/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type PutEnvironmentReleasePlanPathParams = NonNullable<
  operations['PutEnvironmentReleasePlan']['parameters']['path']
>;

export type PutEnvironmentReleasePlanRequestBody = OperationRequestBodyContent<operations['PutEnvironmentReleasePlan']>;

export interface Input extends PutEnvironmentReleasePlanPathParams {
  apiVersion?: string;
  body: PutEnvironmentReleasePlanRequestBody;
  header: NonNullable<operations['PutEnvironmentReleasePlan']['parameters']['header']>;
}

export async function PutEnvironmentReleasePlan(
  { apiVersion, body, header, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().PUT('/api/v2/projects/{projectKey}/environments/{environmentKey}/release-plans/{releasePlanKey}', {
    params: { path, header },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
